export default __webpack_public_path__ + "static/media/cloud2.49ef2dfa.png";